import store from '@store'

export default {
  path: ':slug/new',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "reports-new" */ './NewReport'),
  beforeEnter: (to, from, next) => {
    const reportTypes = store.state.reports.reportTypes
    const report = reportTypes.find(r => r.slug === to.params.slug)
    store.commit('reports/setNewReport', report)
    next()
  }
}
